import { Documento, ProcessoRiferimento, LegalEntityEprocessiRiferimentoResult } from '../../models/data.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from '../../services/data.service';
import { CommonService } from '../../services/common.service';
import { EqualtecService } from '../../services/equaltec.service';

@Component({
  selector: 'app-equaltec-compliance',
  templateUrl: './EqualtecCompliance.component.html',
  styleUrls: ['./EqualtecCompliance.component.css']
})

export class EqualtecCompliance implements OnInit {

  constructor(public translate: TranslateService,
    private dataService: DataService,
    private documentservice: CommonService<Documento>,
    private processoRiferimentoService: CommonService<LegalEntityEprocessiRiferimentoResult>,
    private equaltecService: EqualtecService
  ) { }


  public processiCompliance: ProcessoRiferimento[] = [];
  private filtra: any;





  ngOnInit(): void {
    this.filtra = this.equaltecService.isFiltraCompliance.subscribe(val => {
      this.filtraProcessi()
    });

  }




  filtraProcessi() {
    this.processiCompliance = this.equaltecService.processi.filter(d => d.isAttivo === true);
  }



}
